import { withScridId } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/write-review'

import { withCms, withLayout } from '../cms'

export default compose(withCms(), withLayout(), withScridId())(Page)
